<template>
  <section v-on:click="sectionClicked" class="imageHeader"
    :class="{textShadow: section.textShadow}">
    <div class="theImg" v-if="section.items && section.items.length > 0 && section.items[0][lang]"
      :style="{'background-image': `url(${section.items[0][lang].imageLg})`}">
    </div>
    <div class="theImg noImg" v-else></div>
    <div class="ihOverlay" v-if="section.imageOverlay"
      :style="{opacity: section.overlayOpacity,
      'background-color': section.overlayColor ? `${section.overlayColor}14` : 'rgba(0, 0, 0, .08)'}"></div>
    <div class="ihShadow" v-if="section.imageOverlay"
      :style="{opacity: section.overlayOpacity,
      'background-image': section.overlayColor ? `linear-gradient(to right, ${section.overlayColor}, ${section.overlayColor}4d)`
      : 'linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,.3))'}"></div>
    <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
      <div class="cnt">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      maru1Offset: 40,
      scrolled: false,
      newsIdx: 0,
      ch: null,
      loading: true,

      /**
       * Slider
       *
       */
      sliders: [],
      slideActive: 0,
      sliderpuase: false,
      sliderpuaseForced: false,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sliderMouseEnter() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = true;
    },
    sliderMouseLeave() {
      if (this.sliderpuaseForced) return;
      this.sliderpuase = false;
    },
    forceSliderPause() {
      setTimeout(() => {
        this.sliderpuase = !this.sliderpuase;
        this.sliderpuaseForced = this.sliderpuase;
      });
    },
    sectionClicked() {
      if (this.$refs.header) this.$refs.header.headerClicked();
    },
    prevNews() {
      if (this.newsIdx < 1) return;
      this.newsIdx -= 1;
    },
    nextNews() {
      if (this.newsIdx > 2) return;
      this.newsIdx += 1;
    },
    nextNews2() {
      if (this.newsIdx > 3) return;
      this.newsIdx += 1;
    },
    openVideo(item) {
      this.$refs.videoDialog.open(item.media);
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.imageHeader{
  height: 460px;
  position: relative;
  .theImg{
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    &.noImg{
      background-color: #ccc;
      background-image: url(../../assets/image-black.png);
      background-size: 64px auto;
      opacity: .3;
    }
  }
  .ihOverlay{
    position: absolute;
    left: 0; right: 0; top: 0; bottom: 0;
    background-color: rgba(0, 0, 0, .08);
    z-index: 1;
  }
  .ihShadow{
    position: absolute;
    left: 0; top: 0; bottom: 0; right: 0;
    background-image: linear-gradient(to right, rgba(0,0,0,1), rgba(0,0,0,.3));
    z-index: 2;
    @media (max-width: 840px) {
      background-image: none;
      background-color: rgba(0, 0, 0, .14);
      width: 100%;
    }
  }
  .sectionHeader{
    position: absolute;
    left: 0; right: 0;
    top: 50%;
    transform: translateY(-50%);
    text-align: left;
    color: #fff;
    z-index: 7;
    .cnt{
      margin: 0 40px;
    }
    .sectionTitle{
      font-size: 54px;
      font-weight: 600;
      margin: 0;
    }
    .sectionDesc{
      color: inherit;
      margin: 0;
      font-size: 20px;
      padding: 0;
    }
    .btn{
      display: inline-block;
      padding: 10px 30px;
      border: #fff 1px solid;
      background-color: transparent;
      border-radius: 50px;
      font-size: 20px;
      color: #fff;
      font-weight: 400;
      cursor: pointer;
      transition: all .3s ease;
      margin: 20px 0 0;
      @media (max-width: 1480px) {
        font-size: 17px;
      }
      @media (max-width: 680px) {
        padding: 5px 20px;
        font-size: 14px;
        margin-top: 10px;
        background-color: rgba(0, 0, 0, .4);
      }
      &:hover{
        background-color: rgba(0, 0, 0, .2);
        box-shadow: 0 0 4px rgba(0, 0, 0, .1);
      }
    }
  }
  &.textShadow{
    .sectionHeader{
      .sectionTitle{
        text-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
      .sectionDesc{
        text-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
      }
    }
  }
}
</style>
